import { Component, inject } from '@angular/core';
import { S365Service } from '@clubhub/ignite/services/s365.service';
import { AuthorizeService, ModalStateService } from '@shared/services';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-case-link-modal',
  templateUrl: 'case-link-modal.component.html',
  styleUrls: ['case-link-modal.component.scss'],
})
export class CaseLinkModalComponent {
  private readonly authService = inject(AuthorizeService);
  private readonly s365Service = inject(S365Service);
  private readonly modalState = inject(ModalStateService);

  protected get clientId() {
    return this.authService.user?.sso_id;
  }

  protected get s365Data() {
    return this.s365Service.s365Data;
  }

  protected async newSearch() {
    await firstValueFrom(this.s365Service.removeData());
    this.modalState.topmostModal?.dismiss();
    if (this.modalState.modalStack?.length > 0) {
      this.modalState.modal = this.modalState.topmostModal;
    }
  }

  protected keepDetails() {
    this.modalState.topmostModal?.close();
    if (this.modalState.modalStack?.length > 0) {
      this.modalState.modal = this.modalState.topmostModal;
    }
  }
}
